// Registry of admin-editable slides (German master content).
// `fields` mirror the translations.js structure via dot paths.
// `fontTargets` map the 3 size knobs to stable CSS selectors.
export const EDITABLE_SLIDES = [
  {
    key: 'hero',
    anchor: 'hero',
    label: 'Hero (Start)',
    fields: [
      { path: 'overline', label: 'Overline' },
      { path: 'title', label: 'Titel' },
      { path: 'subtitle', label: 'Untertitel' },
      { path: 'description', label: 'Beschreibung', multiline: true },
    ],
    fontTargets: {
      title: '#hero .hero-title-on-video',
      body: '#hero .hero-subtitle-on-video, #hero .hero-description-on-video',
      overline: '#hero .overline',
    },
  },
  {
    key: 'chance',
    anchor: 'chance',
    label: 'Die unterschätzte Chance',
    fields: [
      { path: 'overline', label: 'Overline' },
      { path: 'title', label: 'Titel' },
      { path: 'body', label: 'Fließtext', multiline: true },
      { path: 'callout', label: 'Zitat / Callout', multiline: true },
    ],
    fontTargets: {
      title: '#chance h2',
      body: '#chance p',
      overline: '#chance .overline',
    },
  },
  {
    key: 'hauptgruende',
    anchor: 'hauptgruende',
    label: 'Sechs Gründe',
    fields: [
      { path: 'overline', label: 'Overline' },
      { path: 'title', label: 'Titel' },
      { path: 'lead', label: 'Einleitung', multiline: true },
    ],
    list: {
      path: 'items',
      label: 'Die 6 Gründe (Reihenfolge per Drag & Drop)',
      itemFields: [
        { path: 'n', label: 'Nr.' },
        { path: 'title', label: 'Titel' },
        { path: 'body', label: 'Text', multiline: true },
      ],
      imageField: 'img',
      imageDefault: (i) => `/source-pptx/image${22 + i}-cut.png`,
    },
    fontTargets: {
      title: '#hauptgruende .hg2-title',
      body: '#hauptgruende .hg2-lead',
      overline: '#hauptgruende .hg2-overline',
    },
  },
  {
    key: 'moeglichkeiten',
    anchor: 'moeglichkeiten',
    label: 'Möglichkeiten',
    fields: [
      { path: 'overline', label: 'Overline' },
      { path: 'title', label: 'Titel' },
      { path: 'subtitle', label: 'Untertitel' },
      { path: 'stigLine', label: 'STIG Zeile' },
      { path: 'stigDrawback', label: 'STIG Vorteil' },
    ],
    list: {
      path: 'items',
      label: 'Vergleichs-Zeilen (Reihenfolge per Drag & Drop)',
      itemFields: [
        { path: 'tag', label: 'Tag' },
        { path: 'name', label: 'Name' },
        { path: 'drawback', label: 'Nachteil' },
      ],
    },
    fontTargets: {
      title: '#moeglichkeiten h2',
      body: '#moeglichkeiten p',
      overline: '#moeglichkeiten .overline',
    },
  },
  {
    key: 'plaene',
    anchor: 'plaene',
    label: 'Solution Pläne',
    fields: [
      { path: 'overline', label: 'Overline' },
      { path: 'title', label: 'Titel' },
      { path: 'sub', label: 'Untertitel', multiline: true },
      { path: 'recommended', label: 'Badge (Beliebt)' },
      { path: 'footnote', label: 'Fußnote', multiline: true },
    ],
    fontTargets: {
      title: '#plaene h2',
      body: '#plaene p',
      overline: '#plaene .overline',
    },
  },
  {
    key: 'innovation',
    anchor: 'innovation',
    label: 'Innovation / Team',
    fields: [
      { path: 'overline', label: 'Overline' },
      { path: 'title', label: 'Titel' },
      { path: 'body', label: 'Fließtext', multiline: true },
      { path: 'leadershipTag', label: 'Leadership-Tag' },
    ],
    list: {
      path: 'team',
      label: 'Gründer (Reihenfolge per Drag & Drop)',
      itemFields: [
        { path: 'name', label: 'Name' },
        { path: 'role', label: 'Rolle' },
      ],
    },
    imageSlots: [
      { key: 'founder0', label: 'Portrait Gründer 1' },
      { key: 'founder1', label: 'Portrait Gründer 2' },
    ],
    fontTargets: {
      title: '#innovation h2',
      body: '#innovation p',
      overline: '#innovation .overline',
    },
  },
  {
    key: 'vip',
    anchor: 'ersparnisse',
    label: 'Ersparnisse (VIP-Beispiel)',
    fields: [
      { path: 'example.title', label: 'Titel' },
      { path: 'example.body', label: 'Fließtext', multiline: true },
      { path: 'example.line1Label', label: 'Zeile 1 — Label' },
      { path: 'example.line1Value', label: 'Zeile 1 — Wert' },
      { path: 'example.line2Label', label: 'Zeile 2 — Label' },
      { path: 'example.line2Value', label: 'Zeile 2 — Wert' },
      { path: 'example.line3Label', label: 'Zeile 3 — Label' },
      { path: 'example.line3Value', label: 'Zeile 3 — Wert' },
      { path: 'example.resultLabel', label: 'Ergebnis — Label' },
      { path: 'example.resultValue', label: 'Ergebnis — Wert' },
    ],
    fontTargets: {
      title: '#ersparnisse h2',
      body: '#ersparnisse p',
      overline: '#ersparnisse .overline',
    },
  },
  {
    key: 'cta',
    anchor: 'cta',
    label: 'CTA (Abschluss)',
    fields: [
      { path: 'overline', label: 'Overline' },
      { path: 'title', label: 'Titel' },
      { path: 'body', label: 'Fließtext', multiline: true },
      { path: 'hint', label: 'Hinweis-Box', multiline: true },
    ],
    fontTargets: {
      title: '#cta h2, #cta [data-testid="cta-title"]',
      body: '#cta p',
      overline: '#cta .overline',
    },
  },
];

export function getPath(obj, path) {
  return path.split('.').reduce((o, k) => (o == null ? undefined : o[k]), obj);
}

export function setPath(obj, path, value) {
  const keys = path.split('.');
  const out = { ...obj };
  let cur = out;
  keys.forEach((k, i) => {
    if (i === keys.length - 1) {
      cur[k] = value;
    } else {
      cur[k] = { ...(cur[k] || {}) };
      cur = cur[k];
    }
  });
  return out;
}
